import { render, staticRenderFns } from "./ImportPhoto.vue?vue&type=template&id=12ebe882"
import script from "./ImportPhoto.vue?vue&type=script&lang=js"
export * from "./ImportPhoto.vue?vue&type=script&lang=js"
import style0 from "./ImportPhoto.vue?vue&type=style&index=0&id=12ebe882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports